// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import {
  initializeFirestore,
  persistentLocalCache,
  persistentMultipleTabManager
} from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
//import { initializeAppCheck, ReCaptchaV3Provider } from 'firebase/app-check';

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCfBhJwYYDH-2GLb1pNj3bcX7Yi4LgGkGI",
  authDomain: "sapling-wedding-app.firebaseapp.com",
  projectId: "sapling-wedding-app",
  storageBucket: "sapling-wedding-app.firebasestorage.app",
  messagingSenderId: "541118186263",
  appId: "1:541118186263:web:77c68a314d995ca2ea6d52"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// TODO: fix app check and re-enable after wedding
// initializeAppCheck(app, {
//   provider: new ReCaptchaV3Provider(process.env.REACT_APP_RECAPTCHA_KEY),
//   isTokenAutoRefreshEnabled: true
// });

// Initialize Firestore with persistent IndexedDB cache (Layer 1 caching).
// After the first load, reads are served from disk instantly; the SDK
// reconciles with the server in the background. Falls back to memory cache
// automatically in private/incognito windows where IndexedDB is unavailable.
export const storage = getStorage(app);

export const db = initializeFirestore(app, {
  localCache: persistentLocalCache({
    tabManager: persistentMultipleTabManager()
  })
});
